import { c as _c } from "react/compiler-runtime";
import CallSplit from "@mui/icons-material/CallSplit";
import History from "@mui/icons-material/History";
import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline";
import { alpha, Box, Chip, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { HomeLandingHeroPreviewRuntime } from "#/features/homePage/ui/landing/HomeLandingHeroPreviewRuntime";
import type { TranslationFunctions } from "#/i18n/i18n-types";
type HomeLandingHeroPreviewProps = {
  LL: TranslationFunctions;
};
const codeSnippet = `function invertTree(root) {
  if (!root) return null;

  const left = invertTree(root.left);
  const right = invertTree(root.right);

  root.left = right;
  root.right = left;
  return root;
}`;
const WINDOW_CONTROLS = ["#ff5f57", "#febc2e", "#28c840"] as const;
export const HomeLandingHeroPreview: React.FC<HomeLandingHeroPreviewProps> = t0 => {
  const $ = _c(76);
  const {
    LL
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "auto",
      sm: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== theme.appDesign.outline) {
    t2 = alpha(theme.appDesign.outline, 0.18);
    $[1] = theme.appDesign.outline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `1px solid ${t2}`;
  let t4;
  if ($[3] !== theme.appDesign.surface) {
    t4 = alpha(theme.appDesign.surface, 0.86);
    $[3] = theme.appDesign.surface;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== theme.appDesign.background) {
    t5 = alpha(theme.appDesign.background, 0.46);
    $[5] = theme.appDesign.background;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `0 24px 60px ${t5}`;
  let t7;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t6) {
    t7 = {
      position: "relative",
      width: "100%",
      minWidth: 0,
      mx: t1,
      borderRadius: 4,
      border: t3,
      bgcolor: t4,
      backdropFilter: "blur(18px)",
      boxShadow: t6,
      overflow: "hidden"
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      xs: "column",
      sm: "row"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      xs: "flex-start",
      sm: "center"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== theme.appDesign.outline) {
    t10 = alpha(theme.appDesign.outline, 0.14);
    $[13] = theme.appDesign.outline;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = `1px solid ${t10}`;
  let t12;
  if ($[15] !== t11) {
    t12 = {
      p: 1.5,
      borderBottom: t11,
      columnGap: 1.5,
      rowGap: 1.25
    };
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== theme.appDesign.background) {
    t13 = WINDOW_CONTROLS.map(color => <Box key={color} sx={{
      width: 11,
      height: 11,
      borderRadius: "50%",
      bgcolor: color,
      boxShadow: `0 0 0 1px ${alpha(theme.appDesign.background, 0.35)} inset`
    }} />);
    $[17] = theme.appDesign.background;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13) {
    t14 = <Stack direction="row" spacing={1} alignItems="center">{t13}</Stack>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      flexWrap: "wrap",
      rowGap: 1
    };
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PlayCircleOutline fontSize="small" />;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== LL) {
    t17 = LL.HOME_HOW_STEP_2_TITLE();
    $[23] = LL;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t17) {
    t18 = <Chip size="small" icon={t16} label={t17} />;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <History fontSize="small" />;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== LL) {
    t20 = LL.REPLAY();
    $[28] = LL;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t20) {
    t21 = <Chip size="small" icon={t19} label={t20} />;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <CallSplit fontSize="small" />;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== LL) {
    t23 = LL.CALLSTACK();
    $[33] = LL;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t23) {
    t24 = <Chip size="small" icon={t22} label={t23} />;
    $[35] = t23;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t18 || $[38] !== t21 || $[39] !== t24) {
    t25 = <Stack direction="row" spacing={1} sx={t15}>{t18}{t21}{t24}</Stack>;
    $[37] = t18;
    $[38] = t21;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t12 || $[42] !== t14 || $[43] !== t25) {
    t26 = <Stack direction={t8} spacing={1.25} justifyContent="space-between" alignItems={t9} sx={t12}>{t14}{t25}</Stack>;
    $[41] = t12;
    $[42] = t14;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        md: "1.05fr 0.95fr"
      },
      minWidth: 0
    };
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  let t29;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      xs: "none",
      md: "block"
    };
    t29 = {
      xs: 1.5,
      sm: 2.5
    };
    $[46] = t28;
    $[47] = t29;
  } else {
    t28 = $[46];
    t29 = $[47];
  }
  let t30;
  if ($[48] !== theme.appDesign.outline) {
    t30 = alpha(theme.appDesign.outline, 0.14);
    $[48] = theme.appDesign.outline;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  const t31 = `1px solid ${t30}`;
  let t32;
  if ($[50] !== t31) {
    t32 = {
      xs: "none",
      md: t31
    };
    $[50] = t31;
    $[51] = t32;
  } else {
    t32 = $[51];
  }
  let t33;
  if ($[52] !== theme.appDesign.outline) {
    t33 = alpha(theme.appDesign.outline, 0.14);
    $[52] = theme.appDesign.outline;
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  const t34 = `1px solid ${t33}`;
  let t35;
  if ($[54] !== t34) {
    t35 = {
      xs: t34,
      md: "none"
    };
    $[54] = t34;
    $[55] = t35;
  } else {
    t35 = $[55];
  }
  let t36;
  if ($[56] !== t32 || $[57] !== t35) {
    t36 = {
      display: t28,
      p: t29,
      minWidth: 0,
      borderRight: t32,
      borderBottom: t35
    };
    $[56] = t32;
    $[57] = t35;
    $[58] = t36;
  } else {
    t36 = $[58];
  }
  let t37;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{
      minWidth: 0
    }}><Typography variant="subtitle2" color="text.secondary">javascript</Typography><Typography variant="caption" color="text.secondary">solution.js</Typography></Stack>;
    $[59] = t37;
  } else {
    t37 = $[59];
  }
  let t38;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      xs: "0.76rem",
      sm: "0.86rem"
    };
    $[60] = t38;
  } else {
    t38 = $[60];
  }
  let t39;
  if ($[61] !== theme.appDesign.accentSoft) {
    t39 = <Stack spacing={1.25}>{t37}<Box component="pre" sx={{
        m: 0,
        p: 0,
        overflowX: "auto",
        fontFamily: "\"IBM Plex Mono\", \"SFMono-Regular\", Consolas, \"Liberation Mono\", monospace",
        fontSize: t38,
        lineHeight: 1.7,
        color: theme.appDesign.accentSoft,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word"
      }}>{codeSnippet}</Box></Stack>;
    $[61] = theme.appDesign.accentSoft;
    $[62] = t39;
  } else {
    t39 = $[62];
  }
  let t40;
  if ($[63] !== t36 || $[64] !== t39) {
    t40 = <Box sx={t36}>{t39}</Box>;
    $[63] = t36;
    $[64] = t39;
    $[65] = t40;
  } else {
    t40 = $[65];
  }
  let t41;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = {
      p: {
        xs: 1.5,
        sm: 2.5
      },
      minWidth: 0
    };
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] !== LL) {
    t42 = <Box sx={t41}><HomeLandingHeroPreviewRuntime LL={LL} /></Box>;
    $[67] = LL;
    $[68] = t42;
  } else {
    t42 = $[68];
  }
  let t43;
  if ($[69] !== t40 || $[70] !== t42) {
    t43 = <Box sx={t27}>{t40}{t42}</Box>;
    $[69] = t40;
    $[70] = t42;
    $[71] = t43;
  } else {
    t43 = $[71];
  }
  let t44;
  if ($[72] !== t26 || $[73] !== t43 || $[74] !== t7) {
    t44 = <Box sx={t7}>{t26}{t43}</Box>;
    $[72] = t26;
    $[73] = t43;
    $[74] = t7;
    $[75] = t44;
  } else {
    t44 = $[75];
  }
  return t44;
};